import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";

import { ImageAttribution } from "../components/ImageAttribution";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SlideDiagram from "../components/cards/slide/Slide";
import SubComponentCard from "../components/SubComponent";

export default function SceneSetter(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-18 font-bold p-16 pb-0">Scenario:</Typography>

      {data.core.map((slide, index) => (
        <ComponentCard
          key={slide.id}
          title={
            data.core.length > 1 ? "Scenario slide " + (index + 1) : "Scenario"
          }
          id={slide.id}
          commentsCount={componentCommentsCount(slide.id)}
        >
          {/* <ComponentPreview>
            <SlideDiagram />
          </ComponentPreview> */}
          <ComponentStepLabel number="1" title="Image:" />
          <ImageAttribution attribution={slide.media} tl={tl} dir={dir} />
          <ComponentStepLabel number="2" title="Caption:" />
          <SubComponentCard
            key={slide.id}
            title="Caption"
            id={slide.id + " caption"}
            commentsCount={componentCommentsCount(slide.id + " caption")}
          >
            <Paper elevation={0} square className="p-16">
              <Grid container spacing={1}>
                <Grid item xs={4} sm={2}>
                  <Typography className="text-14 font-semibold m-0">
                    Text (TL):
                  </Typography>
                </Grid>
                <Grid item xs={8} sm={10}>
                  <Typography className={`${tl} m-0`} dir={dir}>
                    {slide.text_tl}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={2}>
                  <Typography className="text-14 font-semibold m-0">
                    Text (EN):
                  </Typography>
                </Grid>
                <Grid item xs={8} sm={10}>
                  <Typography className="text-14 m-0">
                    {slide.text_en}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </SubComponentCard>
        </ComponentCard>
      ))}
      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </>
  );
}
